import { computed } from '@ember/object';
import YZoomAccuracyBase from './y-zoom-accuracy-base';

export default class YZoomAccuracyClosing extends YZoomAccuracyBase {
  @computed('ticksWithLimits', 'zoomSettings') get enclosingTicks() {
    var base = this; // To specify which are declared in the base class
    var yTicks = base.get('ticksWithLimits');
    var zoomSettings = base.get('zoomSettings');
    var result = null;

    for (var i = yTicks.length - 1; i >= 0; i--) {
      var item = yTicks[i];
      if (item.y >= zoomSettings.y + zoomSettings.height && !result) {
        result = {};
        result.previousTick = yTicks[i + 1];
        result.nextTick = item;
        result.index = i;
      }
    }
    return result;
  }

  @computed('enclosingTicks', 'zoomSettings', 'pxBetweenTicks') get zoomCoverage() {
    var base = this; // To specify which are declared in the base class
    var enclosingTicks = this.enclosingTicks;
    var zoomSettings = base.get('zoomSettings');
    var pxBetweenTicks = parseFloat(base.get('pxBetweenTicks'));
    var coveredArea = zoomSettings.y + zoomSettings.height - enclosingTicks.previousTick.y;
    var percentage = coveredArea / pxBetweenTicks;
    return percentage;
  }

  @computed('zoomCoverage', 'previousTickValue', 'valueDiffBetweenTicks') get actualEdgeValue() {
    var base = this; // To specify which are declared in the base class
    var zoomCoverage = parseFloat(base.get('zoomCoverage'));
    var previousTickValue = parseFloat(base.get('previousTickValue'));
    var valueDiffBetweenTicks = parseFloat(base.get('valueDiffBetweenTicks'));
    var result = previousTickValue - valueDiffBetweenTicks * zoomCoverage;
    return result;
  }
}
